import moment from 'moment';
export const daysToMilliseconds = (days) => {
	return days * 24 * 60 * 60 * 1000;
}
export const dateToTimestamp = (date, fallback, addDayMilis) => {
	return date ? new Date(moment.utc(date).format()).getTime() + (addDayMilis ? 86400000 : 0) : fallback;
};
export const dateToGMTTimestamp = (year, month, day) => {
	return new Date(moment.utc(`${year}-${month}-${day}`).format()).getTime();
};

export const timestampToDate = (ts, format = 'MM/DD/YYYY') => {
	return moment.unix(ts / 1000).format(format);
};

export const timeRelation = time => {
	const today = moment().format('YYYY-MM-DD');
	const wtoday = moment().isoWeekday();
	const diff = moment(moment(time).format('YYYY-MM-DD')).diff(today, 'days');
	const wday = wtoday + diff;
	const thisWeek = wday > 0 && wday < 8;
	return { diff, wday, thisWeek };
};

export const thisWeek = (format = 'YYYY-MM-DD', doFormat = true) => {
	const start = moment().startOf('week');
	const end = moment().endOf('week');
	return {
		start: doFormat ? start.format(format) : start.toDate(),
		end: doFormat ? end.format(format) : end.toDate(),
	};
};

export const thisMonth = (format = 'YYYY-MM-DD', doFormat = true) => {
	const start = moment().startOf('month');
	const end = moment().endOf('month');
	return {
		start: doFormat ? start.format(format) : start.toDate(),
		end: doFormat ? end.format(format) : end.toDate(),
	};
};

export const thisYear = (format = 'YYYY-MM-DD', doFormat = true) => {
	const start = moment().startOf('year');
	const end = moment().endOf('year');
	return {
		start: doFormat ? start.format(format) : start.toDate(),
		end: doFormat ? end.format(format) : end.toDate(),
	};
};
